import React from 'react';
import {IconProps} from "../services/IconConstants";

const UserIcon = ({size, colour, style, className}: IconProps) => {

    return (
        <svg viewBox="0 0 24 24"
             width={size}
             height={size}
             color={colour ? colour : 'var(--text)'}
             style={style}
             className={className}
             fill={"none"}>
            <path d="M13 14H11C7.13401 14 4 17.134 4 21H20C20 17.134 16.866 14 13 14Z" stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round"/>
        </svg>
    );
}

export default UserIcon;